import { SortingState } from '@tanstack/react-table';
import { useState } from 'react';
import { useGetInternalLifeglovUsageQuery } from '../../api/internal';
import { useTenantIds } from '../../hooks/useTenantIds';
import { InternalDashboardSkeleton } from '../components/InternalDashboardSkeleton';
import { InternalTabsList } from '../components/InternalTabsList';
import { LatestLifeglovUsageTile } from '../components/LatestLifeglovUsageTile';

export function LifeglovsTab() {
  const tenantIds = useTenantIds();
  const { data, isFetching } = useGetInternalLifeglovUsageQuery({ tenantIds });
  const [sorting, setSorting] = useState<SortingState>();

  return (
    <div className="flex flex-col gap-4">
      <InternalTabsList />
      {isFetching ? (
        <InternalDashboardSkeleton />
      ) : (
        <LatestLifeglovUsageTile latestLifeglovUsage={data ?? {}} sorting={sorting} onSortingChange={setSorting} />
      )}
    </div>
  );
}
